import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import DaySaveService from '../services/DaySaveService';
import DaySaveSearch from '../records/DaySaveSearch';

const DaySaveActions = {

    async loadFromParams(params) {
        const search = await DaySaveSearch.deserialize(params);

        return this.load(search);
    },

    load (search) {
        AppDispatcher.dispatch({
            search,
            actionType: ActionTypes.DAYSAVE_SEARCH_LOADED
        });
        return search;
    },

    async search (search) {

        AppDispatcher.dispatch({
            actionType: ActionTypes.DAYSAVE_SEARCH_STARTED,
            search
        });

        try {
            const result = await DaySaveService.search(search);

            AppDispatcher.dispatch({
                actionType: ActionTypes.DAYSAVE_SEARCH_FINISHED,
                search,
                searchResults: result
            });

            return result;
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.DAYSAVE_SEARCH_FAILED,
                search,
                error
            });
            throw error;
        }
    },

    selectTicket (fare) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DAYSAVE_TICKET_SELECTED,
            fare
        });
    }
};

export default DaySaveActions;



// WEBPACK FOOTER //
// ./src/actions/DaySaveActions.js